import { ReactNode } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  return (
    <Auth0Provider
      domain={
        process.env.REACT_APP_AUTH0_DOMAIN
          ? process.env.REACT_APP_AUTH0_DOMAIN
          : ''
      }
      clientId={
        process.env.REACT_APP_AUTH0_CLIENT_ID
          ? process.env.REACT_APP_AUTH0_CLIENT_ID
          : ''
      }
      redirectUri={
        process.env.REACT_APP_AUTH_REDIRECT_URL
          ? process.env.REACT_APP_AUTH_REDIRECT_URL
          : ''
      }
      audience={
        process.env.REACT_APP_AUTH0_AUDIENCE
          ? process.env.REACT_APP_AUTH0_AUDIENCE
          : ''
      }
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};
